import dataManager from '../app/common/data_manager';

export const getOAuthLogoutUrl = () => 'https://auth.deriv.com/oauth2/sessions/logout';

export const getOAuthOrigin = () => 'https://auth.deriv.com';

export const requestOauth2Logout = (onWSLogoutAndRedirect) => {
    // Simplified logout - just call the WebSocket logout without OIDC
    // eslint-disable-next-line no-console
    console.log('requestOauth2Logout: Simplified logout without OIDC', !!onWSLogoutAndRedirect);
    if (typeof onWSLogoutAndRedirect === 'function') {
        onWSLogoutAndRedirect();
    }
};

export const requestSingleLogout = async () =>
    // Simplified single logout - no TMB or OIDC checks
    Promise.resolve();

export const requestSingleSignOn = async () => {
    // Simplified single sign-on - no TMB or OIDC authentication
    // Just mark SSO as finished to prevent blocking the application
    
    dataManager.setContract({ sso_finished: true });
    return Promise.resolve();
};
